import { MembershipTierWithAnon } from './types/MembershipTierWithAnon';
import * as gql from './gql';

export type MemberType = 'Anonymous' | gql.typesClient.MembershipTier;
export function getMemberType(tier: MembershipTierWithAnon | null): MemberType {
  if (!tier || tier === 'Anon') return 'Anonymous';
  return tier;
}

export function makeUserAnalyticsData(
  currentUser: gql.typesClient.Query_CurrentUser_CurrentUser | null,
  tier: MembershipTierWithAnon | null,
) {
  const memberType = getMemberType(tier);
  if (!currentUser) return { memberType };

  return {
    ...currentUser,
    userId: currentUser.id,
    memberType,
    member_type: memberType,

    address: {
      city: currentUser.city || '',
      country: currentUser.country || '',
      postalCode: currentUser.zip || '',
      state: currentUser.state || '',
      street: currentUser.address || '',
    },

    firstName: currentUser.first_name || '',
    lastName: currentUser.last_name || '',
    company: { name: currentUser.company || '' },
    company_slug: currentUser.company || null,
    phone: currentUser.phone || '',

    image: currentUser.image?.processed_url || null,
    class_intensity: currentUser?.class_intensity?.map(item => item.id).join(';') || null,
    class_level: currentUser?.class_level?.map(item => item.id).join(';') || null,
    interests: currentUser?.interests?.map(item => item.id).join(';') || null,
    user_goals: currentUser?.user_goals?.map(item => item.id).join(';') || null,
    in_progress_classes:
      currentUser?.in_progress_classes?.map(item => item?.id || null).join(';') || null,
    in_progress_meditations:
      currentUser?.in_progress_meditations?.map(item => item?.id || null).join(';') || null,
    in_progress_courses:
      currentUser?.in_progress_courses?.map(item => item.course.id).join(';') || null,
    purchased_courses:
      currentUser?.purchased_courses?.map(item => item.course.id).join(';') || null,
    courses:
      currentUser?.purchased_courses?.map(item => `course_${item.course.id}`).join(';') || null,
    completed_courses:
      currentUser?.completed_courses?.map(item => item.course.id).join(';') || null,
    favorite_classes:
      currentUser?.favorite_classes?.map(item => item?.content.id || null).join(';') || null,
    favorite_meditations:
      currentUser?.favorite_meditations?.map(item => item?.content.id || null).join(';') || null,
    favorite_articles:
      currentUser?.favorite_articles?.map(item => item?.content.id || null).join(';') || null,
    favorite_teachers:
      currentUser?.favorite_teachers?.map(item => item?.content.id || null).join(';') || null,
    favorite_playlists:
      currentUser?.favorite_playlists?.map(item => item?.content.id || null).join(';') || null,
    recent_class_activity:
      currentUser?.recent_class_activity?.map(item => item?.content.id || null).join(';') || null,
    recent_meditation_activity:
      currentUser?.recent_meditation_activity?.map(item => item?.content.id || null).join(';') ||
      null,
    recent_series_activity:
      currentUser?.recent_series_activity?.map(item => item?.content.id || null).join(';') || null,
    recent_user_created_activity:
      currentUser?.recent_user_created_activity?.map(item => item?.id || null).join(';') || null,
    most_recent_active_course: currentUser?.most_recent_active_course?.course.id || null,
  };
}
